import type { FC } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";

import { AchievementIcon } from "components";
import { Lightbox } from "components/Lightbox";
import type { IBadgeResult } from "pages/Statistics/Tabs/Badges";

import IconArrowLeft from "images/icons/arrow-left.svg";
import IconArrowRight from "images/icons/arrow-right.svg";

interface Props {
  badge: IBadgeResult | null;
  isShown: boolean;
  isNavShown?: boolean;
  goNext: () => void;
  goPrev: () => void;
  onClose: () => void;
}

const NewBadgeModal: FC<Props> = ({ badge, isShown, isNavShown = true, goNext, goPrev, onClose }) => {
  if (badge === null) return null;

  return (
    <Lightbox show={isShown} onHide={onClose} bodyClassName={"pb-40px"} title="Vítáme tě zpátky!">
      <Row>
        <Col xs={"auto"} className="px-0 flex-column d-flex justify-content-center">
          {isNavShown ? (
            <Button className={"btn-circular btn-circular--sm"} variant={"light"} onClick={goPrev}>
              <IconArrowLeft className={"flex-shrink-0"} />
            </Button>
          ) : null}
        </Col>
        <Col className={"text-center"}>
          <p className={"mb-12px"}>{badge.modalTextEarned}</p>
          <div className="achievement--inactive bg-white">
            <AchievementIcon icon={badge.icon} count={badge.count} />
          </div>
        </Col>
        <Col xs={"auto"} className="px-0 flex-column d-flex justify-content-center">
          {isNavShown ? (
            <Button className={"btn-circular btn-circular--sm"} variant={"light"} onClick={goNext}>
              <IconArrowRight className={"flex-shrink-0"} />
            </Button>
          ) : null}
        </Col>
      </Row>
    </Lightbox>
  );
};

export default NewBadgeModal;
